import { Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NavigationLinkDirective } from '../../directives/navigation-link/navigation-link.directive';
import { ShBadgeComponent } from '../badge/badge.component';
import { IconSize } from '../icon/entities/icon-sizes.entity';
import { ShIconModule } from '../icon/icon.module';
import { NavigationItem, NavigationItemIconPosition } from '../navigation-item/entities/navigation-item.entity';

@Component({
    standalone: true,
    selector: 'sh-icon-link',
    templateUrl: './icon-link.component.html',
    imports: [CommonModule, RouterModule, ShBadgeComponent, ShIconModule, NavigationLinkDirective]
})
export class ShIconLinkComponent {
    readonly iconSize: IconSize = IconSize.SMALL;

    readonly navigationItemIconPosition: typeof NavigationItemIconPosition = NavigationItemIconPosition;

    @Input() item!: NavigationItem;

    get iconClassNames(): string {
        let classNames: string[] = [];

        if (this.item.iconPosition && !this.item.badge) {
            classNames = [...classNames, this.item.iconPosition];
        }

        classNames = ['sh-icon-link__icon', ...classNames];

        return classNames.join(' ');
    }

    get badgeClassNames(): string {
        let classNames: string[] = [];

        if (this.item.iconPosition) {
            classNames = [...classNames, this.item.iconPosition];
        }

        classNames = ['sh-icon-link__icon', ...classNames];

        return classNames.join(' ');
    }
}
